<template>
  <dashboard-page title="Reservas"
  subtitle="agenda de reservas do período">
    <modal-loading
      :openModal="isLoading"
      :value="fetchProgress"
      :label="'carregando... ' + fetchProgress.toFixed(0) + '%'"
    ></modal-loading>

    <template #actions>
      <div class="d-flex align-items-center search-row">
        <div
          class="d-flex align-items-center w-100"
          style="
            padding: 7px;
            border: 0.5px solid rgb(218, 218, 218);
            border-radius: 5px;
            background-color: white;
            min-width: 20rem;
          "
        >
          <input
            class="search-input w-100"
            style="border: none"
            v-model="searchQuery"
            placeholder="buscar"
          />
          <button
            v-if="searchQuery"
            type="button"
            class="operacao-search-clear"
            title="Limpar busca"
            @click="clearSearchQuery"
          >
            <i class="fas fa-times"></i>
          </button>
          <i v-else class="fas fa-search text-muted"></i>
        </div>
      </div>

      <div class="d-flex align-items-center operacao-header-actions">
        <button
          type="button"
          class="btn-icon-outline operacao-search-toggle search-row-mobile"
          :class="{ active: showSearchQuery }"
          @click="toggleSearchQuery"
          title="Buscar reserva"
        >
          <i class="fas fa-search"></i>
        </button>

        <!-- DROPDOWN MENU-->
        <b-row align-self="start" class="row-1 text-right mr-0 mb-0">
          <b-dropdown
            menu
            on
            right
            no-caret
            id="operacao-actions"
            variant="secondary"
          >
            <template v-slot:button-content>
              <svg
                width="5"
                height="19"
                viewBox="0 0 5 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="2.19231" cy="2.19231" r="2.19231" fill="#12576e" />
                <circle cx="2.19231" cy="9.49992" r="2.19231" fill="#12576e" />
                <circle cx="2.19231" cy="16.8078" r="2.19231" fill="#12576e" />
              </svg>
            </template>

            <b-dropdown-item
              active
              type="default"
              @click.prevent="callCalendarVerifyReservas"
            >
              <i class="no no-right-arrow"></i>verificar reservas
            </b-dropdown-item>

            <b-dropdown-item
              type="default"
              @click.prevent="callCalendarPeriodSummary"
            >
              <i class="no no-right-arrow"></i>ver resumo do período
            </b-dropdown-item>
          </b-dropdown>
        </b-row>
      </div>
    </template>

    <div
      class="d-flex align-items-center search-row-mobile px-3 mb-3"
      v-if="showSearchQuery"
    >
      <div
        class="d-flex align-items-center w-100"
        style="
          padding: 7px;
          border: 0.5px solid rgb(218, 218, 218);
          border-radius: 5px;
          background-color: white;
        "
      >
        <input
          class="search-input w-100"
          style="border: none"
          v-model="searchQuery"
          placeholder="buscar"
        />
        <button
          v-if="searchQuery"
          type="button"
          class="operacao-search-clear"
          title="Limpar busca"
          @click="clearSearchQuery"
        >
          <i class="fas fa-times"></i>
        </button>
        <i v-else class="fas fa-search text-muted"></i>
      </div>
    </div>

    <div class="content">
      <b-container fluid>
        <div no-body style="min-height: 200px" ref="day_by_day_wrapper">
          <calendar-operacao
            ref="calendarOperacao"
            :eventsCalendar="eventsCalendar"
            :formDate="formDate"
            :showUnpaid="showUnpaid"
            @calendarDateChanged="setCalendarDates"
            @showUnpaidChanged="setShowUnpaid"
          >
          </calendar-operacao>
        </div>
      </b-container>
    </div>
  </dashboard-page>
</template>

<script>
import { DatePicker } from 'element-ui'
import moment from 'moment'
import Fuse from 'fuse.js'
import SearchFilterOperacao from './SearchFilterOperacao.vue'
import CalendarOperacao from './CalendarOperacao.vue'
import ModalLoading from '../../components/ModalLoading/ModalLoading.vue'
import { mapActions, mapGetters } from 'vuex'
import { computed } from 'vue'

export default {
  name: 'Operacao',

  components: {
    DatePicker,
    SearchFilterOperacao,
    CalendarOperacao,
    ModalLoading,
  },

  provide() {
    return {
      isLoading: computed(() => this.isLoading),
    }
  },

  computed: {
    ...mapGetters('report', {
      reservas: 'getBookings',
    }),

    ...mapGetters('product', {
      poisList: 'getPois',
    }),

    ...mapGetters('auth', {
      place: 'getPlace',
      params: 'params',
    }),

    isLoading() {
      return this.fetchProgress > 0 && this.fetchProgress < 100
    },

    calendarReservas() {
      return (this.reservas || []).filter((booking) => {
        const status = String(booking.status || '').toUpperCase()
        if (status === 'CANCELLED') return false
        if (this.showUnpaid) return status === 'UNPAID'
        return status !== 'UNPAID'
      })
    },

    filteredReservas() {
      const bookings = this.calendarReservas
      const query = (this.searchQuery || '').trim()
      if (!query) return bookings

      const fuse = new Fuse(bookings, {
        keys: this.fuseSearchKeys,
        threshold: 0.3,
      })

      return fuse
        .search(query)
        .map((result) =>
          result && result.item !== undefined ? result.item : result
        )
    },

    eventsCalendar() {
      if (this.isLoading) return []

      return this.filteredReservas.map((booking) => {
        const time = moment(booking.data)
          .format('H[h]mm')
          .replace(/h00$/, 'h')
        const code = booking.code || ''
        const client = String(
          (booking.people &&
            booking.people.tableText &&
            booking.people.tableText.groupOwner) ||
            'Cliente'
        ).trim()
        const peopleCount =
          booking.people &&
          booking.people.tableText &&
          booking.people.tableText.count != null
            ? String(booking.people.tableText.count).padStart(2, '0')
            : '--'

        const lineCode = `<span class="bc-booking-code">#${code}</span>`
        const lineClient = `<span class="bc-client-name">${client}</span>`

        booking.eventLabel = `${time} - ${client}`
        if (true) {
          booking.title = `${time} - ${lineClient}`
        } else {
          booking.title = `${lineCode}<br>${lineClient}`
        }
        booking.html = true
        booking.allDay = true
        booking.start = moment(booking.data).format('YYYY-MM-DD')
        booking.tickets = Object.entries(booking.itemPersonType || {})
        booking.borderColor = this.getBookingStatusColor(booking)
        return booking
      })
    },
  },

  data() {
    return {
      formDate: { startDate: '2025-01-01', endDate: '2025-01-31' },
      showFilterSearch: false,
      inputCategories: [],
      selectedCategories: [],
      billsMemBuffer: [],
      fetchProgress: 0,
      searchQuery: '',
      showSearchQuery: false,
      showUnpaid: false,
      fuseSearchKeys: [
        'data',
        'code',
        'cat',
        'status',
        'statusText',
        'seguro.searchText',
        'people.tableText.line1',
        'people.tableText.line2',
        'people.tableText.line3',
        'paymentMethod',
        'resourcePaymentMethod',
        'poi.address',
        'poi.name',
        'poi.place',
        'valor',
        'id',
      ],
    }
  },
  methods: {
    ...mapActions('operacao', ['fetchItineraries']),

    ...mapActions('product', ['fetchPOIs']),

    ...mapActions('report', [
      'fetchBillItems',
      'getBillsMemBuffer',
      'removeMemBufferItem',
    ]),

    toggleSearchQuery() {
      this.showSearchQuery = !this.showSearchQuery
    },

    clearSearchQuery() {
      this.searchQuery = ''
    },

    callCalendarVerifyReservas() {
      const calendar = this.$refs.calendarOperacao
      if (calendar && typeof calendar.emitPeriodChange === 'function') {
        calendar.emitPeriodChange()
      }
    },

    callCalendarPeriodSummary() {
      const calendar = this.$refs.calendarOperacao
      if (calendar && typeof calendar.onDateClick === 'function') {
        calendar.onDateClick({
          el: false,
          date: new Date().toISOString().split('T')[0],
        })
      }
    },

    getBookingStatusColor(booking) {
      const status = String(booking.status || '').toUpperCase()
      const payments = booking.payments || []
      const totalPaid = payments.reduce((acc, payment) => {
        if (String(payment.payment_status || '').toUpperCase() === 'APPROVED') {
          return acc + Number(payment.payment_value || 0)
        }
        return acc
      }, 0)
      const finalValue =
        booking.finalValue != null ? booking.finalValue : booking.valor
      const isBookingPaid = totalPaid >= Number(finalValue || 0)

      const hasCheckin =
        (booking.checkin && booking.checkin.hasCheckin) ||
        (booking.checkins && booking.checkins.length > 0) ||
        (booking.checkin &&
          booking.checkin.list &&
          booking.checkin.list.length > 0)

      if (status === 'CANCELLED') return '#D93051'
      if (status === 'APPROVED' && !isBookingPaid) return '#E67E22'
      if (!isBookingPaid) return '#999'
      if (hasCheckin) return 'rgb(32, 155, 103)'
      return '#1A6884'
    },

    async loadPois() {
      const PLACE_UUID = this.place.uuid || this.place.janooUserUuid
      await this.fetchPOIs({ PLACE_UUID: PLACE_UUID, PRODUCT_UUID: '' })
    },

    getPoiCapacity(POI_UUID, date) {
      var poiIndex =
        this.poisList.length > 0
          ? this.poisList.findIndex((poi) => poi.uuid == POI_UUID)
          : -1
      if (POI_UUID && poiIndex >= 0) {
        const POI = this.poisList[poiIndex]
        const formattedDate = moment(date).format('YYYY-MM-DD hh:mm')
        const formattedMonth = moment(date).format('YYYY-MM')

        if (
          POI.capacity[formattedMonth] &&
          POI.capacity[formattedMonth][formattedDate]
        ) {
          var capacity = POI.capacity[formattedMonth][formattedDate]
          var available = Number(capacity.available)
          var booked = Number(capacity.booked)
          var percentage = ((booked / (available + booked)) * 100)
            .toFixed(0)
            .replace('.', ',')

          return `${percentage}%`
        }
      }

      return '--'
    },

    setFilterDates() {
      this.formDate.startDate = moment().startOf('month').format('YYYY-MM-DD')
      this.formDate.endDate = moment().endOf('month').format('YYYY-MM-DD')
    },

    setCalendarDates(newDates) {
      this.formDate.startDate = moment(newDates.startDate).format('YYYY-MM-DD')
      this.formDate.endDate = moment(newDates.endDate).format('YYYY-MM-DD')
      this.loadItineraries()
    },

    setShowUnpaid(value) {
      this.showUnpaid = !!value
    },

    setInputCategories(cats) {
      this.selectedCategories = cats
    },

    fetchBillsAwait(idx) {
      this.getBillsMemBuffer().then((bufferData) => {
        this.billsMemBuffer = bufferData
      })

      if (!idx) {
        idx = 1
      }
      let popped = false
      if (this.billsMemBuffer.length >= idx) {
        popped = this.billsMemBuffer[idx - 1]
        this.removeMemBufferItem(idx - 1)
        idx++
      }

      let doneStatusCount = this.$store.state.report.requestArrayStatus.filter(
        (resp) => resp == 'done'
      ).length
      var totalRequest = this.$store.state.report.requestArrayStatus.length
      let doneBufferCount = this.billsMemBuffer.filter(
        (resp) => resp == 0
      ).length

      if (
        doneStatusCount == 0 ||
        doneStatusCount < totalRequest ||
        doneBufferCount < totalRequest
      ) {
        setTimeout(
          (i, cb) => {
            this.fetchBillsAwait(i, cb)
          },
          100,
          idx
        )
      } else {
        this.loadingTable = false
        this.loadingFilter = false
        this.loadingTableByPaymentMethod = false
      }
      this.calculateFetchProgress()
    },

    async loadItineraries() {
      const params = {
        startDate: this.formDate.startDate,
        endDate: this.formDate.endDate,
        useFakeData: false,
        daysInternval: 1,
        operation_request: false,
      }

      this.calculateFetchProgress()
      this.fetchBillItems(params)
      this.fetchBillsAwait()
    },

    calculateFetchProgress() {
      var totalRequest = this.$store.state.report.requestArrayStatus.length
      var done = this.billsMemBuffer.filter((resp) => resp == 0).length
      let progress = (done / totalRequest) * 100
      this.fetchProgress = done > 0 ? progress : 0.1
    },
  },

  created() {
    this.setFilterDates()
  },

  async mounted() {
    await this.loadPois()
    if (sessionStorage.getItem('operationViewMode') == undefined) {
      this.loadItineraries()
    }
  },
}
</script>

<style>
.operacao-header-actions {
  gap: 0.35rem;
}

.operacao-search-toggle {
  color: #12576e;
  background: transparent;
  cursor: pointer;
}

.operacao-search-toggle.active {
  background-color: #e8f4f8;
}

.operacao-search-clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.35rem;
  padding: 0;
  width: 1.35rem;
  height: 1.35rem;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #b11b1b;
  cursor: pointer;
  flex-shrink: 0;
}

.operacao-search-clear:hover {
  background-color: #f8f1ee;
  color: #b11b1b;
}
</style>
